import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginGuardService } from '@core/auth/login-guard.service';
import { AlterarSenhaComponent } from '@modules/login/pages/alterar-senha/alterar-senha.component';
import { CadastrarSenhaComponent } from '@modules/login/pages/cadastrar-senha/cadastrar-senha.component';
import { CodigoAcessoComponent } from '@modules/login/pages/codigo-acesso/codigo-acesso.component';
import { RecuperarLoginComponent } from '@modules/login/pages/recuperar-login/recuperar-login.component';
import { RecuperarSenhaComponent } from '@modules/login/pages/recuperar-senha/recuperar-senha.component';
import { PreCadastroComponent } from '@modules/login/pages/pre-cadastro/pre-cadastro.component';
import { AcessoNaoPermitidoComponent } from '@modules/acesso-nao-permitido/acesso-nao-permitido.component';
import { AuthGuardService } from '@core/auth/auth-guard.service';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: '/dashboard' },
  { path: 'dashboard', loadChildren: () => import('./modules/dashboard/dashboard.module').then(m => m.DashboardModule), data: { breadcrumb: 'Dashboard' } },
  { path: 'administracao', loadChildren: () => import('./modules/administracao/administracao.module').then(m => m.AdministracaoModule), data: { breadcrumb: 'Administração' } },
  { path: 'cadastro', loadChildren: () => import('./modules/cadastro/cadastro.module').then(m => m.CadastroModule), data: { breadcrumb: 'Cadastro' } },
  { path: 'relatorio', loadChildren: () => import('./modules/relatorio/relatorio.module').then(m => m.RelatorioModule), data: { breadcrumb: 'Relatórios' } },
  { path: 'login', loadChildren: () => import('./modules/login/login.module').then(m => m.LoginModule) },
  { path: 'roteiro-email', loadChildren: () => import('./modules/roteiro-por-email/roteiro-por-email.module').then(m => m.RoteiroPorEmailModule) },
  { path: 'acesso-nao-permitido', component: AcessoNaoPermitidoComponent, canActivate: [AuthGuardService] }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
